module.exports = __webpack_public_path__ + "img/departamento.9ce5c782.svg";